import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactAvatarEditor from 'react-avatar-editor';
import {FormattedMessage, defineMessages, injectIntl} from 'react-intl';
import classes from './personal-info.scss';
import st from 'core/shared-translations';
import RotateLeft from 'static/images/left_rotate.png';
import RotateRight from 'static/images/right_rotate.png';

const t = defineMessages({
  'avatar-editor.drag-and-zoom-reposition-photo': {
    id: 'avatar-editor.drag-and-zoom-reposition-photo',
    defaultMessage: 'Drag & zoom to reposition your photo.',
    description: 'Instruction label to user to position and set the photo\'s size',
  },
  'avatar-editor.chose-another-photo': {
    id: 'avatar-editor.chose-another-photo',
    defaultMessage: 'Choose a different photo',
    description: 'Link text to open the file system explorer to pick a new photo',
  },
});

class AvatarEditor extends Component {
  state = {
    scale: 1.5,
    rotate: 0,
    borderRadius: 100,
    border: 40,
    width: 150,
    height: 150,
    color: [255, 255, 255, 0.5],
  };

  handleSave = () => {
    const canvasImage = this.editor.getImageScaledToCanvas();
    this.props.handleCanvasImage(canvasImage);
  };

  handleScale = (e) => {
    const scale = parseFloat(e.target.value);
    this.setState({ scale });
  };

  rotateLeft = (e) => {
    e.preventDefault();
    this.setState({rotate: this.state.rotate - 90});
  };

  rotateRight = (e) => {
    e.preventDefault();
    this.setState({rotate: this.state.rotate + 90});
  };

  setEditorRef = (editor) => {
    if (editor) this.editor = editor;
  };

  render() {
    const {formatMessage} = this.props.intl;
    const { userImageUrl } = this.props;
    return (
      <div id="avatar-editor-modal" className="modalContent">
        <div className={`row ${classes['editorRow']}`}>
          <div className="col-xs-3 text-right" style={{paddingRight: 0}}>
            <button onClick={this.rotateLeft} className={`${classes['rotateLeft']}`}>
              <img className={classes['imageRotate']} src={RotateLeft} alt="" />
            </button>
          </div>
          <div className="col-xs-6 no-padding">
            <ReactAvatarEditor
              ref={this.setEditorRef}
              image={userImageUrl === '' ? undefined : userImageUrl}
              scale={parseFloat(this.state.scale)}
              border={this.state.border}
              width={this.state.width}
              height={this.state.height}
              rotate={parseFloat(this.state.rotate)}
              borderRadius={this.state.borderRadius}
            />
            <div className={`${classes['avatarSizingControls']}`}>
              <span className={`${classes['zoomOut']}`}>
                <i id="zmOut" className={`togo-icon togo-icon-image ${classes['zoomOutImg']}`} />
              </span>
              <span className={`${classes['zoomControl']}`}>
                <input
                  name="scale"
                  type="range"
                  onChange={this.handleScale}
                  min="1"
                  max="2"
                  step="0.01"
                  defaultValue="1.5"
                  className={classes['imageScaler']}
                />
              </span>
              <span className={`${classes['zoomIn']}`}>
                <i id="zmIn" className={`togo-icon togo-icon-image ${classes['zoomInImg']}`} />
              </span>
            </div>
          </div>
          <div className="col-xs-3 text-left" style={{paddingLeft: 0}}>
            <button onClick={this.rotateRight} className={`${classes['rotateRight']}`}>
              <img className={classes['imageRotate']} src={RotateRight} alt="" />
            </button>
          </div>
        </div>

        <div className={classes['editPhotoInstruction']}>
          {formatMessage(t['avatar-editor.drag-and-zoom-reposition-photo'])}
        </div>
        <div className={classes['selectOtherPhotoLink']}>
          <a href="#" onClick={this.props.showImageSelectorControl}>
            {formatMessage(t['avatar-editor.chose-another-photo'])}
          </a>
        </div>
        <div className="row buttonRow">
          <div className="col-xs-12 col-sm-6 no-gutter">
            <button
              type="button"
              className="btn btn-default ninety-button marginl-5"
              onClick={this.handleSave}
            >
              <FormattedMessage {...st['shared.done']} />
            </button>
          </div>
          <div className="col-xs-12 col-sm-6 no-gutter">
            <button
              type="button"
              className="btn btn-tertiary ninety-button"
              onClick={this.props.closeModal}
            >
              <FormattedMessage {...st['shared.cancel']} />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

AvatarEditor.propTypes = {
  intl: PropTypes.object.isRequired,
  userImageUrl: PropTypes.string,
  handleCanvasImage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  showImageSelectorControl: PropTypes.func.isRequired,
};

export default injectIntl(AvatarEditor);
